module.exports = __webpack_public_path__ + "img/logo.c8f7a560.svg";